import MetadataService from '@/services/MetadataService'

const createMetadataModule = () => ({
  namespaced: true,
  state: {
    companies: [],
    domains: [],
    skillLevels: [],
    skills: []
  },
  actions: {
    getMetadata: async ({ commit }) => {
      try {
        const { domains, skillLevels, skills } = await MetadataService.getAll()
        commit('SET_DOMAINS', { domains })
        commit('SET_SKILL_LEVELS', { skillLevels })
        commit('SET_SKILLS', { skills })
      } catch (ex) {
        console.error(`Failed to get metadata: ${ex.message || ex}`)
      }
    },

    getCompany: async ({ commit }, companySlug) => {
      try {
        const { companies } = await MetadataService.getCompany(companySlug)
        commit('SET_COMPANIES', { companies })
      } catch (ex) {
        console.error(`Failed to get company: ${ex.message || ex}`)
      }
    }
  },
  getters: {
    domains: (state) => state.domains,
    skillLevels: (state) => state.skillLevels,
    skills: (state) => state.skills,
    companies: (state) => state.companies
  },
  mutations: {
    SET_COMPANIES: (state, { companies }) => {
      state.companies = companies
    },
    SET_DOMAINS: (state, { domains }) => {
      state.domains = domains
    },
    SET_SKILL_LEVELS: (state, { skillLevels }) => {
      state.skillLevels = skillLevels
    },
    SET_SKILLS: (state, { skills }) => {
      state.skills = skills
    }
  }
})

export default createMetadataModule
